import { isPrivateEnv, clearCookieByName } from './../../utils/index';
import { request } from "@weapp/utils";
import { thirdParm } from "../../components/m/standardLogin/type";
import { getQueryString, encryptRsa, getCookie, passportHost, mainHost } from '../../utils';
import { publicUrl, publicUrlapi } from "../../constants";
const host = passportHost();

// 登录
export const login = (params: any) => {
  if (params.password && params.password.indexOf('%symmetric%-') === -1) {
    params = encryptRsa(params, 'password');
  }
  if (params.account){
    params = encryptRsa(params, 'account');
  }
  if (window.sessionStorage.getItem('PASSPORT_LANGTYPE_CHANGED') || isPrivateEnv()) {
    params['language'] = getCookie('langType') || 'zh_CN';
  }
  if (!params.service) {
    params.service = `${window.passport_runInfo.weappUrl}${window.passport_runInfo?.sysLoginRedirectPath || (window.passport_runInfo?.secondFrontUrl ? `${window.passport_runInfo.secondFrontUrl}/` : ``)}`
  } else if (window.passport_runInfo?.sysLoginRedirectPath){
    let path = params.service?.split("?")[0];
    let search = params.service?.split("?")[1] ? `?${params.service?.split("?")[1]}` : '';
    let secondUrl = window.passport_runInfo?.secondFrontUrl || '';
    if (
      path === `${window.passport_runInfo.weappUrl}${secondUrl}` ||
      path === `${window.passport_runInfo.weappUrl}${secondUrl}/`
    ) {
      params.service = `${window.passport_runInfo.weappUrl}${window.passport_runInfo?.sysLoginRedirectPath}${search}`
    }
  }
  try {
    const skinData = JSON.parse(JSON.parse(window.localStorage.getItem('e_customPageData_PC') as any)?.loginSkin) || {};
    if (skinData.pageInfo.hasOwnProperty('tenantSelfOnly')) {
      params['onlySelfTenant'] = skinData.pageInfo.tenantSelfOnly;
    }
  } catch (error) {

  }
  if (window.passport_runInfo?.sysLoginRedirectPath) {
    params['sysLoginRedirectPath'] = window.passport_runInfo?.sysLoginRedirectPath
  }
  return request({
    url: host + `${publicUrlapi}/papi/passport/login/pclogin`,
    method: "POST",
    headers: {
      "langType": getCookie('langType') || 'zh_CN'
    },
    data: params
  });
};
// 登录
export const adminLogin = (params: any) => {
  params = encryptRsa(params, 'password');
  params['language'] = getCookie('langType') || 'zh_CN';
  if (!params.service) {
    params.service = `${window.passport_runInfo.weappUrl}${window.passport_runInfo?.sysLoginRedirectPath || (window.passport_runInfo?.secondFrontUrl ? `${window.passport_runInfo?.secondFrontUrl}/` : '')}`
  }
  if (window.passport_runInfo?.sysLoginRedirectPath) {
    params['sysLoginRedirectPath'] = window.passport_runInfo?.sysLoginRedirectPath
  }
  return request({
    url: host + `${publicUrlapi}/papi/passport/login/detachManagerLogin`,
    method: "POST",
    data: params
  });
};
//获取二维码
export const queryQrUrl = (qrTime?: any) => {
  const params = {} as any;
  // if (window.passport_runInfo?.passportUrl) {//全局拦截，增加weappUrl参数值
  //   params['service'] = window.passport_runInfo?.passportUrl;
  // }
  params['ran'] = Math.random();
  // params['service'] = window.passport_runInfo?.passportUrl || `${window.location.protocol}//${window.location.host}`;

  let requestParams: any = {
    url: host + `${publicUrlapi}/papi/passport/qrlogin/qrUrl?service=${encodeURIComponent(window.passport_runInfo?.passportUrl || `${window.location.protocol}//${window.location.host}`)}`,
    method: "GET",
    params,
  }
  if (qrTime) {
    requestParams.headers = {
      "qrTime": qrTime
    }
  }
  return request(requestParams);
};
//检测二维码
export const checkQrStatus = (etoken: any, loginRedirectUrl?: string) => {
  let urlService = getQueryString("service");
  if (urlService) {
    urlService = decodeURIComponent(urlService);
    urlService = urlService.split?.("?")[0];
  }
  let params = {
    etoken: etoken,
    ran: Math.random(),
    service: urlService || window.passport_runInfo?.weappUrl || ""
  } as any
  if (loginRedirectUrl) { //自定义登录页指定跳转地址
    params.loginRedirectUrl = loginRedirectUrl;
  }
  if (window.location.pathname.indexOf('/customlogin') > -1) {  //自定义登录页扫码登陆后退出登录返回自定义登录页地址
    params.passportCusLoginPath = window.location.pathname.replace(publicUrl, '');
  }
  return request({
    url: host + `${publicUrlapi}/papi/passport/qrlogin/qrStatus`,
    method: "GET",
    params
  });
};


//检测二维码
export const checkQysQrStatus = (data: any) => {
  const formData = new FormData();
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      formData.append(key, data[key]);
    }
  }
  return request({
    url: host + `${publicUrlapi}/papi/passport/qys/qysCheckLogin`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    method: "POST",
    data: formData,
  });
};

//检查是否展示校验码
export const checkVerifyCodeShow = (params: any) => {
  return request({
    url: host + `${publicUrlapi}/papi/passport/login/getSafetyLoginSettingConfig`,
    method: "POST",
    data: encryptRsa(params, "account")
  });
  // return request({
  //   url: host + "/papi/passport/login/getSafetyLoginSettingConfig",
  //   method: "GET",
  //   params: params
  // });
};

//获取第三方登录跳转二维码
export const queryQysQrUrl = (data: any) => {
  const formData = new FormData();
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      formData.append(key, data[key]);
    }
  }
  return request({
    url: host + `${publicUrlapi}/papi/passport/qys/getThirdLoginQysInfo`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    method: "POST",
    data: formData
  });
};

export const thirdteamsLogin = (params: thirdParm) => {
  return request({
    url: host + `${publicUrlapi}/papi/app/basicserver/appThird/thirdLogin`,
    // url: "https://www.yunteams.cn/appThird/thirdLogin",
    method: "POST",
    params,
  });
};

export const getSkinConfig = (path: any, type: any) => {
  return request({
    url: host + `${publicUrlapi}/papi/passport/login/getNewCustomSkinByPath?path=${path}&langType=${getCookie('langType')}&type=${type}`,
    method: "GET",
  });
};
export const getCustomDomainSkin = (domain: any, type: any) => {
  return request({
    url: host + `${publicUrlapi}/papi/passport/login/getNewCustomSkinByDomain?domain=${domain}&langType=${getCookie('langType')}&type=${type}`,
    method: "GET",
  });
};
export const getAppSkinConfig = (path: any) => {
  return request({
    url: host + `${publicUrlapi}/papi/passport/login/getH5CustomSkin?path=${path}`,
    method: "GET",
  });
};
export const checkIntunifyauth = (path: any, type: string) => {
  return request({
    url: host + `${publicUrlapi}/papi/passport/login/checkIntunifyauth?path=${path}&loginType=${type}`,
    method: "GET",
  });
};
export const checkIntunifyauthByDomain = (domain: any, type: string) => {
  return request({
    url: host + `${publicUrlapi}/papi/passport/login/checkIntunifyauthByDomain?domain=${domain}&loginType=${type}`,
    method: "GET",
  });
};

export const getUrlInfo = (type: string = 'pc') => {
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/info/getUrlInfo?type=${type}&service=${encodeURIComponent(window.location.href.replace('passport.', 'weapp.'))}`,
    method: "GET",
  });
};

export const checkLogin = () => {
  const service = getQueryString('service') || encodeURIComponent(window.passport_runInfo?.weappUrl || '');
  return request({
    url: host + `${publicUrlapi}/papi/passport/login/checkLogin${(service ? '?service=' + service : '')}`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    method: "POST"
  });
};

export const queryUserInfoSettingWhenLogin = (params: { tenantKey: string, account: string, clientInfo: string }) => {
  if (params.account) {
    params = encryptRsa(params, "account")
  }
  return request({
    url: host + `${publicUrlapi}/papi/passport/auxiliary/login/queryUserInfoSettingWhenLogin?t=${new Date().getTime()}`,
    params
  });
};
export const sendDynamicCode = (params: { tenantKey: string, account: string }) => {
  return request({
    url: host + `${publicUrlapi}/papi/passport/auxiliary/login/sendDynamicCode`,
    params
  });
};
//获取账号安全登录方式配置
export const getSafeAccount = (data: any) => {
  return request({
    url: `${passportHost()}${publicUrlapi}/papi/passport/login/getLoginTypes`,
    method: "POST",
    data
  });
};
export const clearCookie = () => {
  return request({
    url: `${mainHost()}${publicUrlapi}/papi/app/baseserver/clearCookie`,
    method: "GET",
  });
};
export const setModuleSource = (value: string) => {
  return request({
    url: `${mainHost()}${publicUrlapi}/papi/app/baseserver/info/setModuleSource?value=${value}`,
    method: "GET",
  });
};
//清除缓存
export const clearWeappCookie = (cookies?: any) => {
  return request({
    url: `${mainHost()}${publicUrlapi}/papi/app/baseserver/clearCookieByName?cookieNames=${cookies}`,
    method: "GET",
  });
};
//其他第三方app登录---开放平台
export const openApiLogin = (data: any) => {
  return request({
    url: passportHost() + `${publicUrlapi}/papi/passport/thirdapp/openApiLogin`,
    method: "POST",
    data: {
      loginType: 1,
      ...data
    }
  });
};
//其他第三方app登录---签名
export const signLogin = (data: any) => {
  return request({
    url: passportHost() + `${publicUrlapi}/papi/passport/thirdapp/signLogin`,
    method: "POST",
    data: {
      loginType: 2,
      ...data
    }
  });
};

//登录前查询企业logo

export const queryLogo = (tenantKey?: string) => {
  return request({
    url: '/papi/passport/logo/queryLogo',
    params: {
      tenantKey: tenantKey
    }
  })
}